module.exports = __webpack_public_path__ + "static/media/JUNGHEINRICH-ESC-316Z-1.db5fbca7.jpg";